import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';



import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { ContinueWithBackButtons } from 'components/base/BottomStepComponent';
import { CREATION_STEP_THREE_CONFIG } from 'containers/engagement/campaign/CampaignCreationConfig';
import { validate } from 'containers/engagement/campaign/CreateCampaignValidate';

import { scrollToFirstError } from './CreateCampaignHandleError';

import './CouponCampaignSection.scss';
import './CreateCampaignStepTwo.scss';
import '../../campaign/campaignCreation/KeyVisualSection.scss';

const mapPropsToState = (state) => ({
  status: state.createCampaign.createStatus,
  isPublished: state.createCampaign.campaign.isPublished,
});
function CreateCampaignStepThreeV2() {
  const dispatch = useDispatch();
  const {
    getValues,
    formState: { errors },
    clearErrors,
    setError,
  } = useFormContext();
  const { extraValidate } = CREATION_STEP_THREE_CONFIG;

  const stepChangeAction = (isBack) => {
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 2,
      isBack,
    });
    if (extraValidate) {
      isValid =
        extraValidate({
          getValues,
          setError,
          clearErrors,
        }) && isValid;
    }
    dispatch({
      type: 'createCampaign/stepChange',
      payload: { isBack: isBack, step: 2, isValid },
    });
  };

  useEffect(() => {
    scrollToFirstError(errors, [
      'segments',
      'activeEndDate',
      'visibleEndDate',
      'requiredPoints',
      'perHeadLimit',
    ]);
  }, [errors]);

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_THREE_CONFIG}
        hidePreview={true}
      />
      <ContinueWithBackButtons
        continueAction={() => {
          stepChangeAction(false);
        }}
        backAction={() => {
          stepChangeAction(true);
        }}
      />
    </>
  );
}

export default connect(mapPropsToState)(CreateCampaignStepThreeV2);